import { computed, ref, Ref } from 'vue';
import { ValidationProperties } from '@/models/validation.interface';
import { ModalErrorStates } from '@/models/modal/modal.enum';
import validationPresenter from '@/presenters/validation-presenter';
import datePresenter from'@/presenters/date-presenter';
import store from '@/store';

export default class DateStartCode {
	public datePicker: Ref<HTMLInputElement | null> = ref(null);

	public isFieldValidatedAndMissing = computed((): boolean => {
		return validationPresenter.isPropertyMissing(ValidationProperties.START_DATE);
	});

	public isFieldValidatedAndInvalid = computed((): boolean => {
		const info = store.getters.validationInfoDates();
		return info.invalidTypes.includes(ValidationProperties.START_DATE);
	});

	public shouldFieldBeDisabled = computed((): boolean => {
		return datePresenter.shouldStartDateBeDisabled.value;
	});

	private startDate = computed((): Date | null => {
		return store.getters.startDate();
	});

	private endDate = computed((): Date | null => {
		return store.getters.endDate();
	});

	public prefillDatePicker(): void {
		if (!this.datePicker.value || !this.startDate.value) {
			return;
		}

		this.datePicker.value.value = datePresenter.transformDateObjectToUTCDateString(this.startDate.value);
	}

	public setDate(event: { target: { value: string | null } }): void {
		if (!event.target?.value) {
			return;
		}

		const date = datePresenter.transformUTCDateStringToDateObject(event.target.value);
		store.mutations.setStartDate(date);

		if (this.isFieldValidatedAndMissing.value) {
			validationPresenter.validateMandatoryFields();
		}

		if (this.isFieldValidatedAndInvalid.value) {
			store.mutations.resetValidationInfoDates();
		}

		if (this.endDate.value && datePresenter.doAnyCustomProductDatesFallOutsideBounds(date, this.endDate.value)) {
			store.mutations.setModalErrorState(ModalErrorStates.CUSTOM_PRODUCT_DATE_OUT_OF_BOUNDS);
		}
	}
}
